










import { Component, Prop, Vue } from "vue-property-decorator";
import CommonTabs from "@/employer/components/shared/CommonTabs.vue";
import CommonTab from "@/employer/components/shared/CommonTab.vue";
import CurrentPlan from "@/employer/components/myplans/CurrentPlan.vue";
import PreviousPlan from "@/employer/components/myplans/PreviousPlan.vue";
import { useUserStore } from "@/shared/store/user";

@Component({
  components: {
    CommonTabs,
    CommonTab,
    CurrentPlan,
    PreviousPlan,
  }
})
export default class MyPlans extends Vue {
  userStore = useUserStore();
  currentPlans = [];
  previousPlans = [];
  currentDate = new Date();

  async mounted () {
    const wexEmployerCode = this.userStore.currentEmployer.wexEmployerCode;
    const plans = await this.userStore.getPlanSettings(wexEmployerCode);

    plans.forEach(plan => {
      const isHSA = plan.planName.toLowerCase().indexOf("hsa") > -1 || plan.planName.toLowerCase().indexOf("health savings account") > -1;

      const isInPlanYear = this.currentDate < new Date(plan.planYearEndDate) && this.currentDate >= new Date(plan.planYearStartDate);

      if (isHSA || isInPlanYear) {
        this.currentPlans.push(plan);
      }
      else {
        this.previousPlans.push(plan);
      }
    });
  }


}
